import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private httpClient: HttpClient) { }

  public get<T>(server:string, endpoint: string): Observable<T>{
    let headers =  new HttpHeaders({ 'Content-Type': 'application/json' })    
    return this.httpClient.get<T>(server + endpoint, {headers: headers});
  }
  
  public post<T>(server:string, endpoint: string, body?: any): Observable<T>{
    let headers =  new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<T>(server + endpoint, body, {headers: headers});
  }

  public put<T>(server:string, endpoint: string, body?: any): Observable<T>{
    let headers =  new HttpHeaders({ 'Content-Type': 'application/json' })    
    return this.httpClient.put<T>(server + endpoint, body, {headers: headers});
  }

  public delete<T>(server: string, endpoint: string): Observable<T> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.httpClient.delete<T>(server + endpoint, { headers: headers });
  }
}
